import { render, staticRenderFns } from "./ResetModal.vue?vue&type=template&id=48263210&"
import script from "./ResetModal.vue?vue&type=script&lang=js&"
export * from "./ResetModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48263210')) {
      api.createRecord('48263210', component.options)
    } else {
      api.reload('48263210', component.options)
    }
    module.hot.accept("./ResetModal.vue?vue&type=template&id=48263210&", function () {
      api.rerender('48263210', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Domains/ZoneEditor/ResetModal.vue"
export default component.exports